import {Box, Divider, Typography} from "@mui/material";
import LocationIcon from '@mui/icons-material/Place';
import CallIcon from '@mui/icons-material/Call';
import TextsmsIcon from '@mui/icons-material/Textsms';
import {SocialIcon} from "react-social-icons";

export default function ContactForm() {
    const locationText = "Bethaniëlei 92\n" +
        "\n" +
        "2930, Brasschaat België"
    return (
        <>
            <Box sx={{display: "flex", alignItems: "center", flexDirection: "column"}}>
                <Typography variant="h3" color={"#E39B3B"} sx={{
                    mb: 2,
                    fontFamily: 'Barlow',
                    fontSize: '40px', fontStyle: 'normal', fontWeight: '700', textTransform: "uppercase"
                }}>Contacteer mij</Typography>
                <Typography sx={{
                    fontFamily: 'Barlow',
                    fontStyle: 'normal',
                    fontWeight: '400',
                    fontSize: "18px",
                    textAlign: "center",
                    mb: 2
                }}>
                    Voor een afspraak of extra informatie mag je me altijd bellen of een berichtje sturen!
                </Typography>
                <Divider color="#E39B3B" sx={{mr: 20, ml: 20, mt: 2, mb: 2}} flexItem={true} variant="middle"/>
            </Box>
            <Box sx={{display: "flex", alignItems: "center", flexDirection: "row", justifyContent: "space-around", flexWrap: "wrap"}}>
                <Box className="infoCard" sx={{
                    maxWidth: '300px',
                    height: '250px',
                    padding: '40px 32px',
                    gap: '24px',
                    alignSelf: 'stretch',
                    mb: 3,
                    textAlign: "center"
                }}>
                    <LocationIcon sx={{color: "#E39B3B", width: "50px", height: "50px"}}/>
                    <Typography sx={{fontFamily: 'Barlow', fontSize: '25px', fontStyle: 'normal', fontWeight: '600'}}
                                className={"infoCardHeader"}>Locatie</Typography>
                    <Typography sx={{
                        fontFamily: 'Barlow',
                        fontSize: '20px',
                        fontStyle: 'normal',
                        fontWeight: '500',
                        textAlign: "center"
                    }}
                                className={"infoCardText"}>{locationText}</Typography>
                </Box>
                <Box className="infoCard" sx={{
                    maxWidth: '300px',
                    height: '250px',
                    padding: '40px 32px',
                    gap: '24px',
                    alignSelf: 'stretch',
                    mb: 3,
                    textAlign: "center"
                }}>
                    <CallIcon sx={{color: "#E39B3B", width: "50px", height: "50px"}}/>
                    <Typography sx={{fontFamily: 'Barlow', fontSize: '25px', fontStyle: 'normal', fontWeight: '600'}}
                                className={"infoCardHeader"}>Bel mij</Typography>
                    <Typography sx={{
                        fontFamily: 'Barlow',
                        fontSize: '15px',
                        fontStyle: 'normal',
                        fontWeight: '500',
                        textAlign: "center"
                    }}
                                className={"infoCardText"}>Voor info of een afspraak kan je me altijd bellen</Typography>
                    <Typography sx={{
                        fontFamily: 'Barlow',
                        fontSize: '20px',
                        fontStyle: 'normal',
                        fontWeight: '500',
                        textAlign: "center"
                    }}><a style={{color: "#D3B89B"}} href="tel:32471420613">(+32) 471420613</a></Typography>
                </Box>

                <Box className="infoCard" sx={{
                    maxWidth: '300px',
                    height: '250px',
                    padding: '40px 32px',
                    gap: '24px',
                    alignSelf: 'stretch',
                    mb: 3,
                    textAlign: "center"
                }}>
                    <TextsmsIcon sx={{color: "#E39B3B", width: "50px", height: "50px"}}/>
                    <Typography sx={{fontFamily: 'Barlow', fontSize: '25px', fontStyle: 'normal', fontWeight: '600'}}
                                className={"infoCardHeader"}>Bericht</Typography>
                    <Typography sx={{
                        fontFamily: 'Barlow',
                        fontSize: '15px',
                        fontStyle: 'normal',
                        fontWeight: '500',
                        textAlign: "center"
                    }}
                                className={"infoCardText"}>Klik hieronder om me een berichtje te sturen via sms of whatsapp</Typography>
                    <SocialIcon network="t.me" bgColor="#D3B89B" style={{margin: "5px"}} url="sms:32471420613"/>
                    <SocialIcon network="whatsapp" bgColor="#D3B89B" style={{margin: "5px"}} url="https://wa.me/32471420613"/>
                </Box>
            </Box>
        </>
    )
}